import { ContainerResponseDto } from '@planning/app/api'
import { carrierVisitService } from '@planning/services'
import { Event, IEvent, IQueryHandler, IQueryMessage } from '@tom-ui/utils'

export class GetContainersByVisitIdQuery implements IQueryMessage {
  static type = 'GetContainersByVisitIdQuery'
  type = GetContainersByVisitIdQuery.type

  constructor(public visitIds: number[]) {}

  getKey = () => {
    return JSON.stringify(this)
  }
}

export const getContainersByVisitIdQueryHandler: IQueryHandler<
  GetContainersByVisitIdQuery,
  IEvent<ContainerResponseDto[]>
> = async query => {
  const data = await carrierVisitService.containersByCarrierVisitIds(query.visitIds)

  return new Event(GetContainersByVisitIdQuery.type, data)
}
